/* Autogenerated file. Do not edit manually. */
/* tslint:disable */
/* eslint-disable */
import { Signer, utils, Contract, ContractFactory, Overrides } from "ethers";
import { Provider, TransactionRequest } from "@ethersproject/providers";
import type { Qzuki, QzukiInterface } from "../Qzuki";

const _abi = [
  {
    inputs: [],
    name: "ApprovalCallerNotOwnerNorApproved",
    type: "error",
  },
  {
    inputs: [],
    name: "ApprovalQueryForNonexistentToken",
    type: "error",
  },
  {
    inputs: [],
    name: "BalanceQueryForZeroAddress",
    type: "error",
  },
  {
    inputs: [],
    name: "MintERC2309QuantityExceedsLimit",
    type: "error",
  },
  {
    inputs: [],
    name: "MintToZeroAddress",
    type: "error",
  },
  {
    inputs: [],
    name: "MintZeroQuantity",
    type: "error",
  },
  {
    inputs: [],
    name: "OwnerQueryForNonexistentToken",
    type: "error",
  },
  {
    inputs: [],
    name: "OwnershipNotInitializedForExtraData",
    type: "error",
  },
  {
    inputs: [],
    name: "TransferCallerNotOwnerNorApproved",
    type: "error",
  },
  {
    inputs: [],
    name: "TransferFromIncorrectOwner",
    type: "error",
  },
  {
    inputs: [],
    name: "TransferToNonERC721ReceiverImplementer",
    type: "error",
  },
  {
    inputs: [],
    name: "TransferToZeroAddress",
    type: "error",
  },
  {
    inputs: [],
    name: "URIQueryForNonexistentToken",
    type: "error",
  },
  {
    anonymous: false,
    inputs: [
      {
        indexed: true,
        internalType: "address",
        name: "owner",
        type: "address",
      },
      {
        indexed: true,
        internalType: "address",
        name: "approved",
        type: "address",
      },
      {
        indexed: true,
        internalType: "uint256",
        name: "tokenId",
        type: "uint256",
      },
    ],
    name: "Approval",
    type: "event",
  },
  {
    anonymous: false,
    inputs: [
      {
        indexed: true,
        internalType: "address",
        name: "owner",
        type: "address",
      },
      {
        indexed: true,
        internalType: "address",
        name: "operator",
        type: "address",
      },
      {
        indexed: false,
        internalType: "bool",
        name: "approved",
        type: "bool",
      },
    ],
    name: "ApprovalForAll",
    type: "event",
  },
  {
    anonymous: false,
    inputs: [
      {
        indexed: true,
        internalType: "uint256",
        name: "fromTokenId",
        type: "uint256",
      },
      {
        indexed: false,
        internalType: "uint256",
        name: "toTokenId",
        type: "uint256",
      },
      {
        indexed: true,
        internalType: "address",
        name: "from",
        type: "address",
      },
      {
        indexed: true,
        internalType: "address",
        name: "to",
        type: "address",
      },
    ],
    name: "ConsecutiveTransfer",
    type: "event",
  },
  {
    anonymous: false,
    inputs: [
      {
        indexed: false,
        internalType: "uint8",
        name: "version",
        type: "uint8",
      },
    ],
    name: "Initialized",
    type: "event",
  },
  {
    anonymous: false,
    inputs: [
      {
        indexed: true,
        internalType: "address",
        name: "previousOwner",
        type: "address",
      },
      {
        indexed: true,
        internalType: "address",
        name: "newOwner",
        type: "address",
      },
    ],
    name: "OwnershipTransferred",
    type: "event",
  },
  {
    anonymous: false,
    inputs: [
      {
        indexed: true,
        internalType: "address",
        name: "from",
        type: "address",
      },
      {
        indexed: true,
        internalType: "address",
        name: "to",
        type: "address",
      },
      {
        indexed: true,
        internalType: "uint256",
        name: "tokenId",
        type: "uint256",
      },
    ],
    name: "Transfer",
    type: "event",
  },
  {
    inputs: [],
    name: "AZUKI_MINT_AMOUNT",
    outputs: [
      {
        internalType: "uint16",
        name: "",
        type: "uint16",
      },
    ],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [],
    name: "BEANZ_MINT_AMOUNT",
    outputs: [
      {
        internalType: "uint16",
        name: "",
        type: "uint16",
      },
    ],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [],
    name: "MAX_AMOUNT",
    outputs: [
      {
        internalType: "uint16",
        name: "",
        type: "uint16",
      },
    ],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [],
    name: "PRICE",
    outputs: [
      {
        internalType: "uint256",
        name: "",
        type: "uint256",
      },
    ],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [],
    name: "TEAM_HOLD_NUM",
    outputs: [
      {
        internalType: "uint16",
        name: "",
        type: "uint16",
      },
    ],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "address",
        name: "to",
        type: "address",
      },
      {
        internalType: "uint256",
        name: "tokenId",
        type: "uint256",
      },
    ],
    name: "approve",
    outputs: [],
    stateMutability: "payable",
    type: "function",
  },
  {
    inputs: [],
    name: "azukiRemainCount",
    outputs: [
      {
        internalType: "uint16",
        name: "",
        type: "uint16",
      },
    ],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "address",
        name: "owner",
        type: "address",
      },
    ],
    name: "balanceOf",
    outputs: [
      {
        internalType: "uint256",
        name: "",
        type: "uint256",
      },
    ],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [],
    name: "beanzRemainCount",
    outputs: [
      {
        internalType: "uint16",
        name: "",
        type: "uint16",
      },
    ],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "string",
        name: "newUri",
        type: "string",
      },
    ],
    name: "changeBaseURI",
    outputs: [],
    stateMutability: "nonpayable",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "uint16[]",
        name: "tokenIds",
        type: "uint16[]",
      },
      {
        internalType: "bool",
        name: "azuki",
        type: "bool",
      },
    ],
    name: "checkTokensMinted",
    outputs: [
      {
        internalType: "bool[]",
        name: "",
        type: "bool[]",
      },
    ],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "bytes32",
        name: "root",
        type: "bytes32",
      },
      {
        internalType: "bytes32[]",
        name: "proof",
        type: "bytes32[]",
      },
    ],
    name: "checkWhitelist",
    outputs: [
      {
        internalType: "bool",
        name: "",
        type: "bool",
      },
    ],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "uint256",
        name: "tokenId",
        type: "uint256",
      },
    ],
    name: "getApproved",
    outputs: [
      {
        internalType: "address",
        name: "",
        type: "address",
      },
    ],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [],
    name: "getAvailable",
    outputs: [
      {
        internalType: "uint16",
        name: "",
        type: "uint16",
      },
    ],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "address",
        name: "to",
        type: "address",
      },
      {
        internalType: "uint16[]",
        name: "azukiTokenIds",
        type: "uint16[]",
      },
      {
        internalType: "uint16[]",
        name: "beanzTokenIds",
        type: "uint16[]",
      },
    ],
    name: "holderMint",
    outputs: [],
    stateMutability: "nonpayable",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "string",
        name: "name",
        type: "string",
      },
      {
        internalType: "string",
        name: "symbol",
        type: "string",
      },
      {
        internalType: "string",
        name: "baseURI_",
        type: "string",
      },
      {
        internalType: "address",
        name: "azuki",
        type: "address",
      },
      {
        internalType: "address",
        name: "beanz",
        type: "address",
      },
    ],
    name: "initialize",
    outputs: [],
    stateMutability: "nonpayable",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "address",
        name: "owner",
        type: "address",
      },
      {
        internalType: "address",
        name: "operator",
        type: "address",
      },
    ],
    name: "isApprovedForAll",
    outputs: [
      {
        internalType: "bool",
        name: "",
        type: "bool",
      },
    ],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "uint16",
        name: "",
        type: "uint16",
      },
    ],
    name: "mintByAzukiList",
    outputs: [
      {
        internalType: "bool",
        name: "",
        type: "bool",
      },
    ],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "uint16",
        name: "",
        type: "uint16",
      },
    ],
    name: "mintByBeanzList",
    outputs: [
      {
        internalType: "bool",
        name: "",
        type: "bool",
      },
    ],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [],
    name: "mintStatus",
    outputs: [
      {
        internalType: "uint8",
        name: "",
        type: "uint8",
      },
    ],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [],
    name: "name",
    outputs: [
      {
        internalType: "string",
        name: "",
        type: "string",
      },
    ],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [],
    name: "owner",
    outputs: [
      {
        internalType: "address",
        name: "",
        type: "address",
      },
    ],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "bool",
        name: "mintBeforeHolderMint",
        type: "bool",
      },
      {
        internalType: "address[]",
        name: "accounts",
        type: "address[]",
      },
      {
        internalType: "uint16[]",
        name: "nums",
        type: "uint16[]",
      },
    ],
    name: "ownerMint",
    outputs: [],
    stateMutability: "nonpayable",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "uint256",
        name: "tokenId",
        type: "uint256",
      },
    ],
    name: "ownerOf",
    outputs: [
      {
        internalType: "address",
        name: "",
        type: "address",
      },
    ],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [],
    name: "publicMint",
    outputs: [],
    stateMutability: "payable",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "address",
        name: "",
        type: "address",
      },
    ],
    name: "publicMintedList",
    outputs: [
      {
        internalType: "bool",
        name: "",
        type: "bool",
      },
    ],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [],
    name: "renounceOwnership",
    outputs: [],
    stateMutability: "nonpayable",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "address",
        name: "from",
        type: "address",
      },
      {
        internalType: "address",
        name: "to",
        type: "address",
      },
      {
        internalType: "uint256",
        name: "tokenId",
        type: "uint256",
      },
    ],
    name: "safeTransferFrom",
    outputs: [],
    stateMutability: "payable",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "address",
        name: "from",
        type: "address",
      },
      {
        internalType: "address",
        name: "to",
        type: "address",
      },
      {
        internalType: "uint256",
        name: "tokenId",
        type: "uint256",
      },
      {
        internalType: "bytes",
        name: "_data",
        type: "bytes",
      },
    ],
    name: "safeTransferFrom",
    outputs: [],
    stateMutability: "payable",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "address",
        name: "operator",
        type: "address",
      },
      {
        internalType: "bool",
        name: "approved",
        type: "bool",
      },
    ],
    name: "setApprovalForAll",
    outputs: [],
    stateMutability: "nonpayable",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "bytes4",
        name: "interfaceId",
        type: "bytes4",
      },
    ],
    name: "supportsInterface",
    outputs: [
      {
        internalType: "bool",
        name: "",
        type: "bool",
      },
    ],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [],
    name: "symbol",
    outputs: [
      {
        internalType: "string",
        name: "",
        type: "string",
      },
    ],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "uint256",
        name: "tokenId",
        type: "uint256",
      },
    ],
    name: "tokenURI",
    outputs: [
      {
        internalType: "string",
        name: "",
        type: "string",
      },
    ],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [],
    name: "totalSupply",
    outputs: [
      {
        internalType: "uint256",
        name: "",
        type: "uint256",
      },
    ],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "address",
        name: "from",
        type: "address",
      },
      {
        internalType: "address",
        name: "to",
        type: "address",
      },
      {
        internalType: "uint256",
        name: "tokenId",
        type: "uint256",
      },
    ],
    name: "transferFrom",
    outputs: [],
    stateMutability: "payable",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "address",
        name: "newOwner",
        type: "address",
      },
    ],
    name: "transferOwnership",
    outputs: [],
    stateMutability: "nonpayable",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "uint8",
        name: "status",
        type: "uint8",
      },
    ],
    name: "updateMintStatus",
    outputs: [],
    stateMutability: "nonpayable",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "bytes32",
        name: "root",
        type: "bytes32",
      },
    ],
    name: "updateWhitelistMerkleRoot",
    outputs: [],
    stateMutability: "nonpayable",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "bytes32[]",
        name: "proof",
        type: "bytes32[]",
      },
    ],
    name: "whitelistMint",
    outputs: [],
    stateMutability: "nonpayable",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "address",
        name: "",
        type: "address",
      },
    ],
    name: "whitelistMintedList",
    outputs: [
      {
        internalType: "bool",
        name: "",
        type: "bool",
      },
    ],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [],
    name: "withdraw",
    outputs: [],
    stateMutability: "nonpayable",
    type: "function",
  },
];

const _bytecode =
  "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";

type QzukiConstructorParams =
  | [signer?: Signer]
  | ConstructorParameters<typeof ContractFactory>;

const isSuperArgs = (
  xs: QzukiConstructorParams
): xs is ConstructorParameters<typeof ContractFactory> => xs.length > 1;

export class Qzuki__factory extends ContractFactory {
  constructor(...args: QzukiConstructorParams) {
    if (isSuperArgs(args)) {
      super(...args);
    } else {
      super(_abi, _bytecode, args[0]);
    }
  }

  deploy(
    overrides?: Overrides & { from?: string | Promise<string> }
  ): Promise<Qzuki> {
    return super.deploy(overrides || {}) as Promise<Qzuki>;
  }
  getDeployTransaction(
    overrides?: Overrides & { from?: string | Promise<string> }
  ): TransactionRequest {
    return super.getDeployTransaction(overrides || {});
  }
  attach(address: string): Qzuki {
    return super.attach(address) as Qzuki;
  }
  connect(signer: Signer): Qzuki__factory {
    return super.connect(signer) as Qzuki__factory;
  }
  static readonly bytecode = _bytecode;
  static readonly abi = _abi;
  static createInterface(): QzukiInterface {
    return new utils.Interface(_abi) as QzukiInterface;
  }
  static connect(address: string, signerOrProvider: Signer | Provider): Qzuki {
    return new Contract(address, _abi, signerOrProvider) as Qzuki;
  }
}
